module.exports = __webpack_public_path__ + "401892ef99489412ef460c963c3ae6f7.MP3";